import { IAnalysisSetting } from "shared/api/api";

export const GET_ANALYSIS_SETTINGS_BY_SITE = 'GET_ANALYSIS_SETTINGS_BY_SITE';
export const SAVE_ANALYSIS_SETTING = 'SAVE_ANALYSIS_SETTING';
export interface AnalysisSettingState  {
    analysisSettings: IAnalysisSetting[];
    loading: boolean;
}
